import React, { useEffect } from 'react';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../Hooks/useNotification.hook';
// @ts-ignore
import { useHealthPlanUserHook } from '../../../../HealthPlan/Hooks/useHealthPlanUser';
import { useHealthPlanContext } from '../../../../../Services/HealthPlanContext';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { usePatientDataContext } from '../../../../Patient/Services/PatientDataContext';
import MeddiDENTCreateHealthPlanForm from './MeddiDENTCreateHealthPlanForm';

interface Props {
	patientId: string;
	onHealthPlanCreate: () => void;
}

const MeddiDENTCreateHealthPlan = ({
	patientId,
	onHealthPlanCreate,
}: Props) => {
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { healthPlan } = useHealthPlanContext();
	const { initNewHealthPlanUser } = useHealthPlanUserHook();
	const { patient, getOrLoadPatient } = usePatientDataContext();

	useEffect(() => {
		getOrLoadPatient(patientId);
	}, []);

	const createHealthPlan = async (values: any) => {
		if (healthPlan.id) {
			const response = await initNewHealthPlanUser({
				healthPlanId: healthPlan.id.toString(),
				patientId,
			});

			if ('error' in response) {
				displayGQLError(response);
			} else {
				showNotificationSuccess({
					content: 'patientTreatment.meddiDENT.healthPlanCreated',
				});
				onHealthPlanCreate();
			}
		}
	};

	return (
		<ScrollContainer>
			<MeddiDENTCreateHealthPlanForm
				patient={patient}
				healthPlan={healthPlan}
				onSubmit={createHealthPlan}
			/>
		</ScrollContainer>
	);
};

export default MeddiDENTCreateHealthPlan;
